import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';
import { AuditApiService } from '../../features/audit/services/audit-api.service';
import type { AuditAction, AuditEventRequest } from '../../features/audit/models/audit.model';

@Injectable({ providedIn: 'root' })
export class AuditService {
  private readonly api = inject(AuditApiService);
  private readonly auth = inject(AuthService);

  private readonly buffer: AuditEventRequest[] = [];
  private flushTimer: ReturnType<typeof setTimeout> | null = null;

  readonly enabled = () => this.auth.hasAnyRole(['ROLE_MG3P_AUDIT_INGEST']);

  enqueue(event: Omit<AuditEventRequest, 'clientEventId' | 'occurredAt'>): void {
    if (!this.enabled()) {
      return;
    }
    this.buffer.push({
      ...event,
      clientEventId: crypto.randomUUID(),
      occurredAt: new Date().toISOString(),
    });
    this.agendarFlush();
  }

  flush(): void {
    if (this.buffer.length === 0 || !this.enabled()) {
      return;
    }
    const lote = this.buffer.splice(0, 100);
    this.api.registrarLote(lote).subscribe({ error: () => {} });
  }

  private agendarFlush(): void {
    if (this.flushTimer) {
      return;
    }
    this.flushTimer = setTimeout(() => {
      this.flushTimer = null;
      this.flush();
    }, 1500);
  }
}

export function inferirDominio(url: string): string {
  const match = url.match(/\/api\/v1\/([^/?]+)/);
  return match?.[1] ?? 'desconhecido';
}

export function inferirAcao(metodo: string): AuditAction {
  switch (metodo.toUpperCase()) {
    case 'POST':
      return 'CREATE';
    case 'PUT':
    case 'PATCH':
      return 'UPDATE';
    case 'DELETE':
      return 'DELETE';
    default:
      return 'OTHER';
  }
}

export function inferirResourceType(dominio: string): string {
  const mapa: Record<string, string> = {
    demandas: 'Demanda',
    projetos: 'Projeto',
    programas: 'Programa',
    portfolio: 'Portfolio',
    subportfolio: 'Subportfolio',
    comissoes: 'Comissao',
  };
  return mapa[dominio] ?? dominio;
}

export function extrairResourceId(url: string, dominio: string): string | undefined {
  const re = new RegExp(`/api/v1/${dominio}/([^/?]+)`);
  const match = url.match(re);
  const id = match?.[1];
  if (!id || id === 'novo') {
    return undefined;
  }
  return id;
}
